export { default as Social } from './Social';
export { default as SocialIcon } from './Icons';
